export interface RoomContentContextSources {
  primarySource?: string;
  secondarySource?: string;
}

export interface RoomContentContextProps extends RoomContentContextSources {
  isContact?: boolean;
  opportunityId?: string;
  roomUUID?: string;
  templateId?: string;
  visitorId?: string;
}

/**
 * Consistently builds the source name for preparing contents for a room,
 * which is only necessary in "vendor mode", which uses URL contents instead
 * of contents from the library.
 *
 * This is used for 3 uses cases, specifically:
 *  - Room's review step: generates new URLs for the URL contents from a room,
 *    those new URL will end up on the structure which makes that piece of content
 *    always use the overwritten URL for that particular room
 *      - If the deal or room name change, URLs are re-generated
 *      - Also used for the flow of creating a room from a template
 *  - External provider selector: to use as the source for fetching external
 *    assets. External assets can only be obtained if a primary source (deal
 *    name or room template name) exists, so they are always generated with
 *    a valid source for the room/room template.
 *  - View URL contents: to override the URL from a URL content that was generated
 *    from an external asset. This allows to determine from where that piece
 *    of content is being viewed.
 */
export const getContentSourceName = (context?: RoomContentContextSources) => {
  if (!context) {
    return '';
  }

  const { primarySource, secondarySource } = context;

  if (!primarySource) {
    return '';
  }

  return secondarySource
    ? `${primarySource},${secondarySource}`
    : primarySource;
};
